export enum UserStatus {
  available = 'available',
  awayFromPhone = 'awayFromPhone',
  missingOrInvalidPhone = 'missingOrInvalidPhone',
  onActiveCall = 'onActiveCall',
}
